import { FlaskIcon } from "../lib/icons";

/** True until the founder flips REACT_APP_STUDENT_CAMPAIGNS_OPEN=true: every campaign on the site is sample content. */
export const isPrototypeMode = () =>
  String(process.env.REACT_APP_STUDENT_CAMPAIGNS_OPEN || "").toLowerCase() !== "true";

/**
 * PrototypeNotice — one-line strip (audit item M6) that sits near any campaign
 * content while the platform is a preview. It must inform without outranking
 * the student's story or the Donate action, so it is quiet by design.
 */
export const PrototypeNotice = ({ testid = "prototype-notice", className = "mb-8" }) => {
  if (!isPrototypeMode()) return null;
  return (
    <p
      role="note"
      data-testid={testid}
      className={`${className} flex w-fit max-w-full flex-wrap items-center gap-x-2 gap-y-1 rounded-full border border-tangerine/50 bg-tangerine/[0.08] py-2 pl-3 pr-4 text-[13px] leading-snug text-ink`}
    >
      <FlaskIcon className="h-4 w-4 shrink-0 text-tangerine" aria-hidden="true" />
      <span className="font-semibold">Sample campaign, this is not a real student</span>
    </p>
  );
};
